import axios from 'axios';
import throttle from 'lodash/throttle';
import { Alert } from '../helpers/utils';
import { GENERIC_ERROR_MESSAGE, TOAST_TIMEOUT } from '../constants';

const requester = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  headers: {
    Authorization:
      'Bearer 918cf576-6c79-4d73|sTOZBixJzkUMe/MilMAkstU51iM8oEgt16sPJcCji8Q=',
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

const showSuccessAlert = (response: any) => {
  const {
    config: {
      alertSuccessMessage = false,
      alertErrorMessage = false,
      alertMessage = false
    },
    data
  } = response;
  if (data && data.message) {
    if (data.status === 0 && (alertErrorMessage || alertMessage)) {
      Alert.error(data.message);
    } else if (data.status === 1 && (alertSuccessMessage || alertMessage)) {
      Alert.success(data.message);
    }
  }
  return response;
};
const alertError = throttle(Alert.error, TOAST_TIMEOUT);
const showErrorAlert = (error: any) => {
  if (error.response) {
    const {
      config: { alertErrorMessage = false, alertMessage = false },
      data,
      statusText
    } = error.response;
    if (alertErrorMessage || alertMessage) {
      if (data && data.message) {
        Alert.error(data.message);
      } else if (statusText) Alert.error(statusText);
    }
  } else if (error.message === 'Network Error') {
    alertError(GENERIC_ERROR_MESSAGE, { header: 'Network Error' });
  }
  return Promise.reject(error);
};

requester.interceptors.response.use(showSuccessAlert, showErrorAlert);

const extractServerData = ({ data }: any) => data;
const extractServerError = (error: any) => {
  if (error.response) {
    if (!error.response.data) {
      return Promise.reject(
        new Error(error.response.statusText || error.response.status)
      );
    }
    return Promise.reject(error.response.data);
  }
  return Promise.reject(error);
};

requester.interceptors.response.use(extractServerData, extractServerError);

export { requester };
